
import { reqSearchList } from '@/api'

//仓库存储数据的地方
let state = {
    //搜索模块返回的数据
    searchList: {}
};
//唯一可以修改仓库数据地方【工人】
let mutations = {

    GETSEARCHLIST(state, searchList) {
        state.searchList = searchList;
    }

};
//可以处理业务逻辑【if、异步语句等等】
let actions = {
    async getSearchList({ commit }, searchParams) {
        let result = await reqSearchList(searchParams);
        if (result.resultCode == 10000) {
            commit('GETSEARCHLIST', result.result);
        }
    }
};
//仓库计算属性
let getters = {
    totalCount(state) {
        return state.searchList.totalCount || 0;
    },
    noticeList(state) {
        return state.searchList.resultList || [];
    },
};

//对外暴露小仓库
export default {
    state,
    mutations,
    actions,
    getters
}